import {
  CardKind,
  CardLevel,
  KindSet,
  LevelSet,
  PlayableId,
} from "../types";

export function buildingName(kind: CardKind, level: CardLevel): PlayableId {
  return `${kind}-${level}` as PlayableId;
}

export function isValidKind(kind: string): kind is CardKind {
  return KindSet.has(kind as CardKind);
}

export function isValidLevel(
  kind: CardKind,
  level: number,
): level is CardLevel {
  return LevelSet.has(level as CardLevel);
}

export function assertIsValidCard(
  kind: string,
  level: number,
): { kind: CardKind; level: CardLevel } {
  if (!isValidKind(kind) || !isValidLevel(kind, level))
    throw new Error(`Invalid Card (${level}-${kind})`);
  return { kind, level };
}